// rutaMetodos.js
import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ----------------------- helpers comunes -----------------------
const authHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("jwt") ||
    "";

  return token
    ? { token, Authorization: `Bearer ${token}` }
    : {};
};

const toISO = (d) => (d ? new Date(d).toISOString() : undefined);

const toApiTipo = (t) => {
  const s = String(t || "").toLowerCase();
  if (s === "efectivo") return "efectivo";
  if (s === "transferencia") return "transferencia";
  if (s === "icheq" || s === "echeq") return "echeq";
  // En la UI usamos "CHEQUE" genérico; en API suele ser "cheque_tercero"
  if (s === "cheque" || s === "cheque_tercero" || s === "cheque propio" || s === "cheque_propio")
    return "cheque_tercero";
  return "efectivo";
};

// ----------------------- METODOS (CRUD) -----------------------
export const getMetodos = async () => {
  const url = `${BASE_URL}/metodos`;
  try {
    const resp = await axios.get(url, { headers: authHeaders() });
    if (resp.data?.ok && Array.isArray(resp.data.metodos)) {
      return resp.data.metodos;
    }
    return [];
  } catch (error) {
    console.error("❌ Error en getMetodos:", error);
    return [];
  }
};

export const getMetodoById = async (id) => {
  const url = `${BASE_URL}/metodos/${id}`;
  try {
    const resp = await axios.get(url, { headers: authHeaders() });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener metodo",
    };
  }
};

export const postMetodo = async (metodoData) => {
  const url = `${BASE_URL}/metodos`;
  try {
    const resp = await axios.post(url, metodoData, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear metodo",
    };
  }
};

export const putMetodo = async (id, metodoData) => {
  const url = `${BASE_URL}/metodos/${id}`;
  try {
    const resp = await axios.put(url, metodoData, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar metodo",
    };
  }
};

export const deleteMetodo = async (id) => {
  const url = `${BASE_URL}/metodos/${id}`;
  try {
    const resp = await axios.delete(url, { headers: authHeaders() });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar metodo",
    };
  }
};

// ----------------------- ORDEN DE COBRO -----------------------
// Normaliza y envía la OC para que el backend acepte los enums de tipo
export const postOrdenCobro = async (oc) => {
  const url = `${BASE_URL}/ordencobro`;

  // Normalización de medios y retenciones
  const payload = {
    ...oc,
    medios: (oc.medios || []).map((m) => ({
      ...m,
      tipo: toApiTipo(m.tipo),
      importe: Number(m.importe || 0),
      fecha: toISO(m.fecha),
      fechaValor: toISO(m.fechaValor),
      fechaPagoDiferido: toISO(m.fechaPagoDiferido),
      fechaLiquidacion: toISO(m.fechaLiquidacion),
    })),
    retenciones: (oc.retenciones || []).map((r) => ({
      ...r,
      importe: Number(r.importe || 0),
      fecha: toISO(r.fecha),
    })),
  };

  // Útil para depurar:
  // console.log("[OC] tipos enviados:", payload.medios.map(m => m.tipo), payload);

  try {
    const resp = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return resp.data;
  } catch (error) {
    // Propaga el mensaje del server si existe
    const data = error.response?.data;
    console.error("❌ postOrdenCobro error:", data || error);
    return {
      ok: false,
      error: data || "Error al guardar la orden",
    };
  }
};
